module.exports = __webpack_public_path__ + "img/3.8a103398.png";